import { Injectable } from '@angular/core';
import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { Http } from '@angular/http';

@Injectable()
export class PagosFondeadoresService {

  private service_url;

  constructor(
    private constantsService: ConstantsService,
    private http: Http,
    private authService: AutenticacionService,
    private validatorService: ValidatorService,
    private errorService: ErrorsService
  ) {
    this.service_url = this.constantsService.apiURL + '/pagos-fondeador';
  }

  getDefaultSchedule() {
    return {
      'idEsquemaInversion':'',
      'idFondeador': '',
      'tipo_pago': '',
      'monto_pago':'',
      'forma_pago': null,
      'num_referencia': '',
      'fecha_pago': '',
      'monto_penalizacion': null,
      'status': '',
      'url_archivo': '',
      'nombre_archivo': '',
      'numero_ciclo': ''
    };
  }

  public validarPago(data: any){
    console.log("Validando pago... ", data);

    let error = [];

    if(!this.validatorService.required(data["tipo_pago"])){
      error["tipo_pago"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["monto_pago"])){
      error["monto_pago"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["numero_ciclo"])){
      error["numero_ciclo"] = this.errorService.required;
    }

    // if(!this.validatorService.required(data["forma_pago"])){
    //   error["forma_pago"] = this.errorService.required;
    // }

    if(!this.validatorService.required(data["num_referencia"])){
      error["num_referencia"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["fecha_pago"])){
      error["fecha_pago"] = this.errorService.required;
    }

    // if(!this.validatorService.required(data["monto_penalizacion"])){
    //   error["monto_penalizacion"] = this.errorService.required;
    // }

    return error;
  }

  public registrarPagoInversion(data: any, archivo: any) {
    //Convertimos todo el json a FormData
    let formData : FormData = new FormData();
    //Agregamos al form data
    formData.append('idEsquemaInversion', data.idEsquemaInversion);
    formData.append('idFondeador', data.idFondeador);
    formData.append('tipo_pago', data.tipo_pago);
    formData.append('monto_pago', data.monto_pago);
    formData.append('forma_pago', data.forma_pago);
    formData.append('num_referencia', data.num_referencia);
    formData.append('fecha_pago', data.fecha_pago);
    formData.append('monto_penalizacion', data.monto_penalizacion);
    formData.append('status', data.status);
    formData.append('url_archivo', data.url_archivo);
    formData.append('nombre_archivo', data.nombre_archivo);
    if(archivo != undefined){
      //Archivo
      let file: File = archivo[0];
      formData.append('file', file, file.name);
    }else{
      formData.append('file', null);
    }
    formData.append('numero_ciclo', data.numero_ciclo);

    return this.http.post(this.service_url, formData, this.authService.getAuthHeaders());

  }

  public getPagosInversionById(idInversion){
    return this.http.get(this.service_url +"?idEsquemaInversion="+idInversion, this.authService.getAuthHeaders());
  }

  public getPagoUnicoById(idPago: number){
    return this.http.get(this.service_url+"/unico-pago?idPago="+idPago, this.authService.getAuthHeaders());
  }

  public updatePago(data:any, idPago: number){
    return this.http.put(this.service_url+"?idPago="+idPago, data, this.authService.getAuthHeaders());
  }

  public deletePago(idPago: number){
    return this.http.delete(this.service_url+"?idPago="+idPago, this.authService.getAuthHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/pagos-fondeadores.service.ts